import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IGalleryStore,
} from '../../mobx-store/storeInterfaces/galleryInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';

interface IProps extends WithSnackbarProps {
  galleryStore: IGalleryStore;
  countryStore: CountryStore;
  history: any;
}

@inject('galleryStore')
@inject('countryStore')
@observer
class Gallery extends Component<IProps> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  constructor(props: IProps) {
    super(props);
    this.title = translate('galleryListPageTitle', {
    });
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/gallery/${this.props.galleryStore.galleryList[index].imageId}/edit`);
  };

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.galleryStore.updateImageStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableUpButtonCellClicked = (index: number, key: string) => {
    this.props.galleryStore.swapTwoImageOrder(index, index - 1)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableDwonButtonCellClicked = (index: number, key: string) => {
    this.props.galleryStore.swapTwoImageOrder(index, index + 1)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handelAdd = (): void => {
    this.props.history.push('/gallery/new');
  };

  getAddAdButton = () => ({
    title: translate('galleryListAddButton', {
    }),
    onAdd: this.handelAdd,
  });

  getAdsTableHeader = () => [
    {
      title: translate('galleryListImageColumnTitle', {
      }),
    },
    {
      title: translate('galleryListStatusColumnTitle', {
      }),
    },
    {
      title: translate('galleryListOrderColumnTitle', {
      }),
    },
    {
      title: translate('galleryListEditColumnTitle', {
      }),
    },
  ];

  getAdsTableData = () => this.props.galleryStore.galleryList
    .map((image) => ({
      ...image, edit: 'Edit',
    }));

  getAdsTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Image',
      key: 'image',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: translate('galleryListStatusActive', {
      }),
      inactiveLabel: translate('galleryListStatusInactive', {
      }),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'OrderButtons',
      key: 'order',
      upButtonText: 'Up',
      downButtonText: 'Down',
      onUpButtonClick: this.handleTableUpButtonCellClicked,
      onDownButtonClick: this.handleTableDwonButtonCellClicked,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.addButton = this.getAddAdButton();
    this.tableHeader = this.getAdsTableHeader();
    this.tableData = this.getAdsTableData();
    this.tableCellTypes = this.getAdsTableCellTypes();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('galleryListNoImageMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.galleryStore.getGalleryRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore, galleryStore,
    } = this.props;
    await countryStore.getUserManagedCountries();

    galleryStore.getGallery(countryStore.managedCountries);
  }
}

export default Gallery;
